export default __webpack_public_path__ + "static/media/Snd1.9b6edada.mp3";